<template>
  <div>
    <div class="app-card-header primary-actions">
      <div class="heading-block">
        <h4 class="heading">Competitors Coverage</h4>
      </div>
      <div class="actions-block">
        <!--Category Filter-->
        <div class="dropdown-filter">
          <v-autocomplete
            @change="updateByFilters($event, 'category')"
            :value="getSelectedFilters.category"
            :items="getCategories"
            :loading="category.isLoading"
            :search-input.sync="category.search"
            :disabled="getChartStatus.loading"
            noFilter
            :ripple="false"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            hide-details
            clear-icon
            append-icon="expand_more"
            item-text="name"
            item-value="id"
            label="Category"
            no-data-text="Type to search"
            solo
            flat
          >
            <template v-slot:item="{ item }">
              <v-list-tile-content>
                <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </div>
        <!--Brands Select-->
        <div class="dropdown-filter">
          <v-autocomplete
            @change="updateByFilters($event, 'brand')"
            :value="getSelectedFilters.brand"
            :items="brands"
            :loading="brand.isLoading"
            :search-input.sync="brand.search"
            :disabled="getChartStatus.loading"
            noFilter
            :ripple="false"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            hide-details
            clear-icon
            append-icon="expand_more"
            item-text="name"
            item-value="id"
            label="Brand"
            no-data-text="Type to search"
            solo
            flat
          >
            <template v-slot:item="{ item }">
              <v-list-tile-content>
                <v-list-tile-title :class="`option-level-${item.level}`" v-text="item.name"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </div>
        <!--Reset Button-->
        <v-btn
          :disabled="!allowRequest || getChartStatus.loading"
          color="primary"
          flat
          small
          :ripple="false"
          @click="resetFilter"
        >
          <v-icon>autorenew</v-icon>
        </v-btn>
      </div>
    </div>
    <Chart
      :brand="brand.model"
      :category="category.model"
      :height="chartHeight"
      :chartOptions="chartOptions"
      :chartStatus="getChartStatus"
      :columnWidth="dynamicColumn" />
    <div class="card-footer justify-end text-xs-right pt-0">
      <template v-if="!getChartStatus.noData">
        <v-btn
          class="ma-0"
          color="primary"
          flat
          small
          :ripple="false"
          :disabled="getChartStatus.loading"
          @click="openModal"
        >
          Full Screen <v-icon class="ml-1">fullscreen</v-icon>
        </v-btn>
        <div class="separator-line"></div>
        <!--Download Excel-->
        <v-tooltip top max-width="235px" :content-class="[`${getThemeColor === '0' ? 'dark-tooltip' : ''} +  i-tooltip`]">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn
                class="ma-0"
                color="primary"
                flat
                small
                :ripple="false"
                @click="downloadExcelHandler({
                task: 'loadModule',
                downloadExcel: true,
                payload: {
                  category_id: getSelectedFilters.category,
                  brand_id: getSelectedFilters.brand,
                  module_id: 1
                }
              })"
              >
                <v-icon>icon-icon</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Download Excel</span>
        </v-tooltip>
        <v-dialog
          v-model="popup.dialog"
          :dark="getThemeColor === '0'"
          persistent
          fullscreen
          transition="dialog-bottom-transition"
          attach
        >
          <v-card class="competitors-coverage-dialog">
            <v-toolbar card dark color="primary">
              <v-btn icon dark flat :ripple="false" @click="popup.dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Competitors Coverage</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <Chart
                :brand="brand.model"
                :category="category.model"
                :chartStatus="getChartStatus"
                :chartOptions="chartOptions"
                height="600"/>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </div>
</template>

<script>
import { AppUrl } from '@/assets/js/variables'
import Chart from './chart'
export default {
  name: 'block',
  props: {
    chartHeight: {
      type: [String, Number],
      default: null
    },
    columnWidth: {
      type: [Number, String],
      default: null
    }
  },
  components: {
    Chart
  },
  data: () => ({
    category: {
      isLoading: false,
      search: null
    },
    brand: {
      isLoading: false,
      search: null
    },
    popup: {
      dialog: false
    },
    dynamicColumn: null,
    allowRequest: true,
    timer: 1
  }),
  methods: {
    updateByFiltersRequest () {
      this.$store.dispatch('competitorsCoverageModule/getChart', {
        brandId: this.getSelectedFilters.brand,
        categoryId: this.getSelectedFilters.category,
        elemRef: this.$refs.chartCompetitorsCoverage,
        elemRefPopup: this.$refs.chartCompetitorsCoveragePopup
      })
    },
    updateByFilters (e, key) {
      if (!this.allowRequest) return
      this.$store.commit('competitorsCoverageModule/SET_selectedFilters', { value: e, key: key })
      this.updateByFiltersRequest()
    },
    resetFilter () {
      this.$store.commit('competitorsCoverageModule/RESET_selectedFilters')
      this.$store.dispatch('competitorsCoverageModule/getChart', {
        brandId: 0,
        categoryId: 0,
        elemRef: this.$refs.chartCompetitorsCoverage,
        elemRefPopup: this.$refs.chartCompetitorsCoveragePopup
      }).then(() => {
        this.allowRequest = true
      }).catch(() => {
        this.allowRequest = true
      })
    },
    openModal () {
      this.popup.dialog = true
    },
    dynamicColumnWidth () {
      this.dynamicColumn = this.chartOptions.xaxis.categories.length / 0.7
    },
    downloadExcelHandler (params) {
      console.log('Params', params)
      let form = document.createElement('form')
      form.setAttribute('method', 'post')
      form.setAttribute('action', AppUrl)
      form.setAttribute('target', 'targetForm')
      for (let i in params) {
        if (params.hasOwnProperty(i)) {
          let input = document.createElement('input')
          input.type = 'hidden'
          input.name = i
          input.value = JSON.stringify(params[i])
          form.appendChild(input)
        }
      }
      document.body.appendChild(form)
      window.open('', 'targetForm')
      form.submit()
      form.remove()
    }
  },
  computed: {
    getChartStatus () {
      return this.$store.state.competitorsCoverageModule.chartStatus
    },
    getCategories () {
      return this.$store.state.competitorsCoverageModule.categories
    },
    getSelectedFilters () {
      return this.$store.state.competitorsCoverageModule.selectedFilters
    },
    brands () {
      return this.$store.state.competitorsCoverageModule.brands
    },
    chartOptions () {
      return this.$store.state.competitorsCoverageModule.chartOptions
    },
    getThemeColor () {
      return this.$store.state.auth.userInfo.themeColor
    }
  },
  watch: {
    'category.search': function (val) {
      if (val === '') {
        this.$store.commit('competitorsCoverageModule/RESET_currentFilter', { key: 'category' })
        this.updateByFiltersRequest()
        return
      }
      // Don't send request on selection
      if (this.getCategories && this.getCategories.find(el => val === el.name)) return
      let vm = this
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.category.isLoading = true
        this.$store.dispatch('competitorsCoverageModule/getCategories', {
          categoryName: val,
          brandId: vm.getSelectedFilters.brand
        }).then(() => {
          this.category.isLoading = false
        })
      }, 300)
    },
    'brand.search': function (val) {
      if (val === '') {
        this.$store.commit('competitorsCoverageModule/RESET_currentFilter', { key: 'brand' })
        this.updateByFiltersRequest()
        return
      }
      // Don't send request on selection
      if (this.brands && this.brands.find(el => val === el.name)) return
      let vm = this
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.brand.isLoading = true
        this.$store.dispatch('competitorsCoverageModule/getBrands', {
          brandName: val,
          categoryId: vm.getSelectedFilters.category
        }).then(() => {
          this.brand.isLoading = false
        })
      }, 300)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/competitors-coverage/Container.vue